import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=2a53b7b5&scoped=true&"
import script from "./ProBadge.vue?vue&type=script&lang=js&"
export * from "./ProBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=2a53b7b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53b7b5",
  null
  
)

export default component.exports